<div class="modal fade show floor-map-add" role="dialog" tabindex="-1" style="display: block;">
    <div class="modal-dialog" role="document" style="min-width: 86%; width: 100%;">
        <div class="modal-content">
            <div>
                <div class="modal-header">
                    <h5 class="modal-title">
                        <div style="float: left;">
                            <div style="vertical-align: inherit;">
                                <div style="vertical-align: inherit;">Map Onboarding</div>
                            </div>
                        </div>
                        <div style="float: left; margin-left: 200px; color:red">{{error}}</div>
                    </h5><button style="background-color: transparent; border: none;"
                        (click)="closePopup()"><i class="fa fa-times" aria-hidden="true"></i></button>
                </div>
            </div>
            <div class="modal-body" style="height: 76vh;overflow-y: scroll;">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="">
                            <div class="row">
                                <div class="col-3 mt-0">
                                    <label class="alignment">Display Name<sup
                                            style="color: red; font-weight: 600; font-size: 18px;">*</sup></label>
                                    <input [(ngModel)]="displayName" placeholder="Enter Display Name"
                                        class="form-control" (ngModelChange)="changeDisplayName($event)" />
                                </div>
                                <div class="col-3 mt-0">
                                    <label class="alignment">Map Type<sup
                                            style="color: red; font-weight: 600; font-size: 18px;">*</sup></label>
                                    <ng-select [items]="maptype" [searchable]="true" bindLabel="map_type"
                                        bindValue="map_type" placeholder="Enter Map Type" 
                                        [(ngModel)]="map_type" (ngModelChange)="changeMapType($event); checkValid()" required>
                                    </ng-select>
                                </div>
                                <div class="col-3 mt-0">
                                    <label class="alignment">Region</label>
                                    <input type="text" placeholder="Enter Region" matInput
                                        (ngModelChange)="changeRegion($event)" [formControl]="myControl" [matAutocomplete]="auto"
                                        class="form-control" [(ngModel)]="region">
                                    <mat-autocomplete #auto="matAutocomplete">
                                        <mat-option *ngFor="let region of filteredOptions | async" [value]="region">
                                            {{region}}
                                        </mat-option>
                                    </mat-autocomplete>
                                </div>
                                <div class="col-3 mt-0">
                                    <label class="alignment">Campus</label>
                                    <input type="text" placeholder="Enter Campus" matInput
                                        (ngModelChange)="changeCampus($event)" [formControl]="campusControl" [matAutocomplete]="campus"
                                        class="form-control" [(ngModel)]="selectedCampuse">
                                    <mat-autocomplete #campus="matAutocomplete">
                                        <mat-option *ngFor="let campus of campusFilterOptions | async" [value]="campus">
                                            {{campus}}
                                        </mat-option>
                                    </mat-autocomplete>

                                </div>
                                <div class="col-3 mt-0">
                                    <label class="alignment">Building <sup *ngIf="map_type=='Composite'"
                                        style="color: red; font-weight: 600; font-size: 18px;">*</sup></label>
                                    <input type="text" placeholder="Enter Building" matInput
                                        (ngModelChange)="changeBuilding($event)" [formControl]="buildingControl" [matAutocomplete]="build"
                                        class="form-control" [(ngModel)]="selectedBuilding">
                                    <mat-autocomplete #build="matAutocomplete">
                                        <mat-option *ngFor="let build of buildingFilterOptions | async" [value]="build">
                                            {{build}}
                                        </mat-option>
                                    </mat-autocomplete>

                                </div>
                                <div class="col-3 mt-0">
                                    <label class="alignment">Floor</label>
                                    <input [(ngModel)]="floor" placeholder="Enter Floor"
                                        (ngModelChange)="changeFloor($event)" class="form-control" />
                                </div>
                                <div class="col-3 mt-0">
                                    <label class="alignment">South West Lat <sup *ngIf="map_type=='Composite'"
                                        style="color: red; font-weight: 600; font-size: 18px;">*</sup></label>
                                    <input type="number" step=any [(ngModel)]="southWestLat" class="form-control"
                                        placeholder="Enter South West Lat" (ngModelChange)="changeSouthWestLat($event)" />
                                </div>
                                <div class="col-3 mt-0">
                                    <label class="alignment">South West Lng <sup *ngIf="map_type=='Composite'"
                                        style="color: red; font-weight: 600; font-size: 18px;">*</sup></label>
                                    <input type="number" step=any [(ngModel)]="southWestLng" class="form-control"
                                        placeholder="Enter South West Lng" (ngModelChange)="changeSouthWestLng($event)" />
                                </div>
                                <div class="col-3 mt-0">
                                    <label class="alignment">North East Lat <sup *ngIf="map_type=='Composite'"
                                        style="color: red; font-weight: 600; font-size: 18px;">*</sup></label>
                                    <input type="number" step=any [(ngModel)]="northEastLat" class="form-control"
                                        placeholder="Enter North East Lat" (ngModelChange)="changeNorthEastLat($event)" />
                                </div>
                                <div class="col-3 mt-0">
                                    <label class="alignment">North East Lng <sup *ngIf="map_type=='Composite'"
                                        style="color: red; font-weight: 600; font-size: 18px;">*</sup></label>
                                    <input type="number" step=any [(ngModel)]="northEastLng" class="form-control"
                                        placeholder="Enter North East Lng" (ngModelChange)="changeNorthEastLng($event)" />
                                </div>
                                <div *ngIf="map_type != 'Composite'" class="col-3 mt-0">
                                    <label class="alignment">Scale</label>
                                    <input [(ngModel)]="scaleZoom" class="form-control" placeholder="Enter Scale"
                                        (ngModelChange)="changeScaleZoom($event)" />
                                </div>
                                <div *ngIf="map_type == 'Composite'" class="col-3 mt-0">
                                    <label class="alignment">Zoom</label>
                                    <input type="number" step=any maxlength="2" [(ngModel)]="scaleZoom" class="form-control" placeholder="Enter Zoom"
                                        (ngModelChange)="changeScaleZoom($event)" />
                                </div>
                                <div class="col-3 mt-0">
                                    <label class="alignment">Area (Sq ft)</label>
                                    <input type="number" step=any [(ngModel)]="area" class="form-control"
                                        placeholder="Enter Area (Sq ft)" (ngModelChange)="changeArea($event)" />
                                </div>
                                <!-- <div class="col-3 mt-0"  *ngIf="map_type == 'PDF'">
                                    <label class="alignment">Address</label>
                                    <input [(ngModel)]="address" class="form-control" placeholder="Enter Address"
                                        (ngModelChange)="changeAddress($event)" />
                                </div> -->
                                <div class="col-3 mt-0"  >
                                    <label class="alignment">Address <sup *ngIf="map_type=='Composite'"
                                        style="color: red; font-weight: 600; font-size: 18px;">*</sup></label>
                                    <input  #searchInput 
                                    type="text" [(ngModel)]='address' (ngModelChange)="checkValid()"  placeholder="Search location"  class=" form-control search-input"/>
    </div>
                               <!-- *ngIf="map_type == 'Composite'" -->
                                <div class="col-3 mt-0">
                                    <label class="alignment">Latitude</label>
                                    <input [(ngModel)]="latitude" class="form-control" placeholder="Enter Latitude"
                                        disabled />
                                </div>
                                <div class="col-3 mt-0">
                                    <label class="alignment">Longitude</label>
                                    <input [(ngModel)]="longitude" class="form-control" placeholder="Enter Longitude"
                                        disabled />
                                </div>
                                <div class="col-3">
                                    <div class="form-group data-tableForm">

                                        <div class="fileUpload btn btn-primary" style="float: right; margin-top: 35px ">
                                            <div>Upload Map</div>
                                            <input type='file' id='uploadBtn' class="upload"
                                                style="text-align: center; display: block; margin: 3px auto; color: transparent"
                                                name='file' accept="{{map_type=='PDF'?'.pdf': 'image/*' }}"
                                                (change)="handleFileUpload($event)" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p class="map_upload" *ngIf="!imageUrl && data?.from == 'addNewMapFromWalktest'"><span class="red-dot">*</span> Map upload is required.</p>
                            <div class="row">
                                <div class="col-md-12">


                                    <mat-tab-group [selectedIndex]="tabIndex">
                                        <mat-tab label="Map">

                                            <div class="" style="height: 50vh;">

                                                <google-map #gMap id="map" [center]="center" [zoom]="zoom"
                                                    height="550px" width="100%" style="position:relative;"
                                                    [options]="options">
                                                    <map-ground-overlay [url]="imageUrl"
                                                        [bounds]="imageBounds"></map-ground-overlay>
                                                    <!-- <map-marker *ngIf="!imageUrl" [position]="markerPosition" [options]="northEastMarkerOption" (mapDragend)="centerUpdate($event)"></map-marker> -->
                                                    <map-marker *ngIf="map_type == 'Composite'" [position]="northEast" [label]="'North East'"
                                                        [title]="'North East'" [options]="northEastMarkerOption"
                                                        (mapDragend)="northEastMarkerDrag($event)">
                                                    </map-marker>
                                                    <map-marker *ngIf="map_type == 'Composite'" [position]="southWest"
                                                        (mapDragend)="southWestMarkerDrag($event)"
                                                        [label]="'South West'" [title]="'South West'"
                                                        [options]="southWestMarkerOption">
                                                    </map-marker>
                                                </google-map>

                                            </div>
                                        </mat-tab>
                                        <mat-tab label="Image" *ngIf="map_type == 'Composite'">

                                            <div class="row" style="height: 45vh;">

                                                <img [src]="imageUrl">

                                                <div *ngIf="!imageUrl"
                                                    style="justify-content: center; text-align: center; display: flex;">
                                                    <p>Please Upload Image</p>
                                                </div>

                                            </div>


                                        </mat-tab>
                                        <mat-tab label="PDF" *ngIf="map_type == 'PDF'">

                                            <div class="row" style="height: 45vh;">
                                                
                                                <pdf-viewer [src]="imageUrl" [original-size]="false"
                                                    [zoom-scale]="'page-fit'" [autoresize]="true"
                                                    [stick-to-page]="zoomescale" [fit-to-page]="true"
                                                    style="width: 100%; height:100%;display:block" #pdfviewerref>
                                                </pdf-viewer>
                                                <div *ngIf="!imageUrl"
                                                    style="justify-content: center; text-align: center; display: flex;">
                                                    <p>Please Upload Image</p>
                                                </div>
                                            </div>

                                        </mat-tab>
                                    </mat-tab-group>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <div class="mt-2" *ngIf="action === 'Import'" style="margin-right:420px">
                {{ index + 1 }} of {{ importData.length }}
                </div>

                <button class="btn btn-danger" color="primary">
                <div style="vertical-align: inherit;">
                    <div style="vertical-align: inherit;" (click)="closePopup()">Cancel</div>
                </div>
            </button>
                <button *ngIf="action == 'Import'" class="btn btn-primary" color="primary" [disabled]="isFirst" (click)="navigate('previous')">
                    Previous
                </button>
                <button *ngIf="action == 'Import'" class="btn btn-primary" color="primary" [disabled]="isLast" (click)="navigate('next')">
                    Next
                </button>
                <button [disabled]="disabled || isCompositeInvalid || checkValidation()" *ngIf="!updateButton" class="btn btn-primary" color="primary">
                    <div style="vertical-align: inherit;">
                        <div style="vertical-align: inherit;"  (click)="createRecord()">Save</div>
                    </div>
                </button>
                <button class="btn btn-primary" color="primary" *ngIf="updateButton">
                    <div style="vertical-align: inherit;">
                        <div style="vertical-align: inherit;"  (click)="updateRecord()">Update</div>
                    </div>
                </button>
                <button  *ngIf="action == 'Import'" class="btn btn-primary" color="primary">
                    <div style="vertical-align: inherit;">
                        <div style="vertical-align: inherit;"  (click)="saveAll()">Save All</div>
                    </div>
                </button>
            </div>
        </div>
    </div>
</div>